import { normalizeRulebookExport, RulebookExportError, validateRulebook } from "@next-platform/packages-ts-types";
const errorMessage = (error) => (error instanceof Error ? error.message : String(error));
/**
 * Parse an exported rulebook file: JSON → `normalizeRulebookExport` → `validateRulebook`.
 * Validation issues never block the import; they are returned with the definition.
 */
export default function parseRulebookImport({ text }) {
    let envelope;
    try {
        envelope = JSON.parse(text);
    }
    catch (error) {
        return { error: "Invalid JSON: " + errorMessage(error) };
    }
    let definition;
    try {
        definition = normalizeRulebookExport(envelope);
    }
    catch (error) {
        if (error instanceof RulebookExportError) {
            return { error: error.message };
        }
        return { error: errorMessage(error) };
    }
    return { definition, validation: validateRulebook(definition) };
}
